export interface Brand {
  id: string;
  name: string;
  logo: string;          // 브랜드 로고 이미지 URL
  description: string;   // 브랜드 한 줄 소개
  origin: string;        // 제조국
  productIds: string[];  // 이 브랜드에 속하는 제품 ID 목록
}

export interface MonthlyPick {
  productId: string;
  rank: number;
  reason: string;        // 추천 이유 한 줄
}

// ✅ 브랜드 수정 방법:
// - name: 브랜드명
// - logo: 브랜드 로고 이미지 URL (직접 교체 가능)
// - description: 브랜드 소개 문구
// - productIds: 이 브랜드에 속하는 제품 ID (products.ts의 id와 일치해야 함)

export const brands: Brand[] = [
  {
    id: "masters",
    name: "마스터즈",
    logo: "https://public.readdy.ai/ai/img_res/0f67f992cd23f41eabcff422c6defb47.jpg",
    description: "국내 1위 도어락 브랜드. 15년 기술력의 프리미엄 보안 솔루션",
    origin: "국내",
    productIds: ["1", "2", "3", "5"],
  },
  {
    id: "unico",
    name: "유니코",
    logo: "https://readdy.ai/api/search-image?query=unico%20brand%20logo%2C%20modern%20sleek%20typography%20logo%20design%2C%20smart%20door%20lock%20brand%2C%20clean%20minimalist%20wordmark%2C%20contemporary%20corporate%20identity%2C%20white%20background&width=300&height=150&seq=brand_unico&orientation=landscape",
    description: "슬림 디자인과 스마트 기술의 조화. 감각적인 도어락 전문 브랜드",
    origin: "국내",
    productIds: ["4", "6"],
  },
];

// ✅ 이달의 인기제품 수정 방법:
// - productId: products.ts의 제품 id
// - rank: 순위 (1, 2, 3...)
// - reason: 추천 이유 (카드에 표시됨)

export const monthlyPicks: MonthlyPick[] = [
  { productId: "1", rank: 1, reason: "지문인식 + 앱 제어 올인원" },
  { productId: "4", rank: 2, reason: "슬림 디자인 인기 급상승" },
  { productId: "2", rank: 3, reason: "가성비 최강 프리미엄" },
];
